export default __webpack_public_path__ + "static/media/business-ahs-icon-5.a603c205.png";